const topics = [
  { name: '暗夜追踪', count: '128万讨论', size: 'lg' },
  { name: '国产剧推荐', count: '96万讨论', size: 'md' },
  { name: '韩剧追番', count: '87万讨论', size: 'md' },
  { name: '科幻大片', count: '75万讨论', size: 'sm' },
  { name: '悬疑烧脑', count: '68万讨论', size: 'lg' },
  { name: '动漫新番', count: '59万讨论', size: 'sm' },
  { name: '古装权谋', count: '52万讨论', size: 'md' },
  { name: '综艺搞笑', count: '44万讨论', size: 'sm' },
  { name: '纪录片精选', count: '38万讨论', size: 'md' },
];

export default function TopicsSection() {
  return (
    <section
      id="topics"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100 scroll-mt-16"
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          热门话题
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          {topics.map((topic) => {
            const sizeClasses =
              topic.size === 'lg'
                ? 'px-5 py-3 text-base'
                : topic.size === 'md'
                  ? 'px-4 py-2.5 text-sm'
                  : 'px-3 py-2 text-xs';

            return (
              <div
                key={topic.name}
                className={`${sizeClasses} rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer flex items-center gap-2 whitespace-nowrap`}
              >
                <span className="font-medium text-foreground-800">{topic.name}</span>
                <span className="text-foreground-500">{topic.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}